import React, { FC } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { PrivateRoute } from 'common/AuthRoute';
import { AdditionalDevicesPage } from 'pages/SuperAdminModule/AdditionalDevicesManagement/AdditionalDevicesPage';
import { NewAdditionalDevicePage } from 'pages/SuperAdminModule/AdditionalDevicesManagement/NewAdditionalDevicePage';

const AdditionalDevicesManagementPage: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute
        exact
        path={`${path}/new`}
        component={NewAdditionalDevicePage}
      />
      <PrivateRoute exact path={path} component={AdditionalDevicesPage} />
    </Switch>
  );
};

// eslint-disable-next-line import/no-default-export
export default AdditionalDevicesManagementPage;
